import { render } from "./NotPbMajor.vue?vue&type=template&id=51b00b59&scoped=true"
import script from "./NotPbMajor.vue?vue&type=script&lang=js"
export * from "./NotPbMajor.vue?vue&type=script&lang=js"

import "./NotPbMajor.vue?vue&type=style&index=0&id=51b00b59&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b00b59"]])

export default __exports__